import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lighthouse',
  templateUrl: './lighthouse.component.html',
  styleUrls: ['./lighthouse.component.scss']
})
export class LighthouseComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
